<div
  class="dialog-content-wrapper note-dialog"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
>
  <mat-toolbar matDialogTitle class="mat-accent m-0 note-toolbar">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ title }}</span>
      <div
        class="actions"
        fxLayout="row"
        fxLayoutAlign="start center"
        style="cursor: default"
      >
        <mat-divider
          *ngIf="this.showNoteType"
          class="style-fix"
          [vertical]="true"
        ></mat-divider>

        <div style="display: contents" (mousedown)="$event.stopPropagation()">
          <mat-form-field
            [ngStyle]="{ display: !showNoteType ? 'none' : 'inline' }"
            placeholder=""
            class="form-control"
            title=""
            floatLabel="never"
            style="
              margin-top: 12px;
              font-size: 16px;
              width: 250px;
              padding-top: 8px;
            "
          >
            <mat-select
              [hidden]="!showNoteType"
              class="form-control"
              placeholder="Note Type"
              name="noteTypeControl"
              [disabled]="readOnly || userReadOnly || !hasSubjectUserEditPrivs"
              matTooltip="Select Note Type"
              aria-label="Note Type"
              [value]="selectedNoteType?.id"
              (valueChange)="onNoteTypeChanged($event)"
            >
              <mat-select-trigger>
                <span *ngIf="selectedNoteType == null"> Note Type </span>
                <span *ngIf="selectedNoteType && selectedNoteType.id > 0">
                  {{ this.selectedNoteType.name }}
                </span>
              </mat-select-trigger>
              <mat-option style="font-size: 14px" [value]="0">
                -- None --</mat-option
              >
              <mat-option
                style="font-size: 14px"
                *ngFor="let noteType of noteTypes"
                [value]="noteType.id"
              >
                {{ noteType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-divider class="style-fix" [vertical]="true"></mat-divider>

          <button
            mat-icon-button
            class="mat-icon-button"
            (click)="toggleStar($event)"
            aria-label="Toggle star"
            matTooltip="Toggle Starred"
            [disabled]="userReadOnly || !hasSubjectUserEditPrivs"
          >
            <mat-icon class="star" *ngIf="note?.note.starred">star</mat-icon>
            <mat-icon class="fg-icon" *ngIf="!note?.note.starred"
              >star_outline</mat-icon
            >
          </button>

          <button
            mat-icon-button
            class="mat-icon-button"
            (click)="toggleImportant($event)"
            aria-label="Toggle important"
            matTooltip="Toggle Important"
            [disabled]="userReadOnly || !hasSubjectUserEditPrivs"
          >
            <mat-icon class="important" *ngIf="note?.note.important"
              >error</mat-icon
            >
            <mat-icon class="fg-icon" *ngIf="!note?.note.important"
              >error_outline</mat-icon
            >
          </button>

          <button
            mat-icon-button
            class="mat-icon-button"
            (click)="toggleSensitive($event)"
            aria-label="Toggle sensitive"
            matTooltip="Toggle Sensitive"
            [disabled]="userReadOnly || !hasSubjectUserEditPrivs"
          >
            <mat-icon class="sensitive" *ngIf="note?.note.sensitive"
              >lock</mat-icon
            >
            <mat-icon class="fg-icon" *ngIf="!note?.note.sensitive"
              >lock_open</mat-icon
            >
          </button>

          <mat-divider class="style-fix" [vertical]="true"></mat-divider>

          <button
            mat-icon-button
            class="mat-icon-button"
            (click)="saveAndClose()"
            aria-label="Close dialog"
            matTooltip="Close"
          >
            <mat-icon class="fg-icon">close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <div (mousedown)="$event.stopPropagation()" style="display: contents">
    <div *ngIf="!userReadOnly && hasSubjectUserEditPrivs" class="px-24 py-8 m-0 mb-8">
      <note-editor
        #editor
        class="note-editor"
        [setFocus]="true"
        (onContentChanged)="contentChanged($event)"
        [value]="content"
        [disableRightClick]="note?.sequenceId"
        [readOnly]="(note?.sequenceId && note?.sequenceId > 0) || readOnly || !hasSubjectUserEditPrivs"
      ></note-editor>
    </div>

    <div
      *ngIf="userReadOnly || !hasSubjectUserEditPrivs"
      class="note-detail"
      [innerHTML]="content | safeHtml"
    ></div>

    <div
      *ngIf="!userReadOnly && hasSubjectUserEditPrivs"
      mat-dialog-actions
      class="m-0 p-24"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div>
        <button
          *ngIf="readOnly || !hasSubjectUserEditPrivs"
          mat-raised-button
          type="submit"
          [disabled]="!hasChanges"
          (click)="saveContentChange()"
          class="save-button mat-accent"
          aria-label="SAVE CHANGES"
          matTooltip="Save Changes"
        >
          SAVE CHANGES
        </button>
        <button
          *ngIf="!readOnly && hasSubjectUserEditPrivs"
          mat-raised-button
          type="submit"
          [disabled]="!hasChanges"
          (click)="savedraft()"
          class="save-button mat-accent"
          aria-label="SAVE DRAFT"
          matTooltip="Save as draft"
        >
          SAVE DRAFT
        </button>
        <button
          *ngIf="!readOnly && hasSubjectUserEditPrivs"
          mat-raised-button
          type="submit"
          [disabled]="!hasChanges"
          (click)="confirmSubmit()"
          class="save-button mat-accent"
          aria-label="SAVE AND LOCK"
          matTooltip="Save and lock"
        >
          SAVE AND LOCK
        </button>
      </div>
    </div>
  </div>
</div>
